import { useFeatureFlagCompat } from '@platform/core/feature-flags';

import type { FeatureFlagKey } from './feature-flags';

/**
 * @returns {[boolean, (boolean) => void]} array containing feature flag state and setter
 */
export const useFeatureFlag = useFeatureFlagCompat<FeatureFlagKey>;
